import React, { useEffect } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { getSeminarByType } from '../../../actions/summerInternships';
import { getSeminars } from '../../../selectors/seminars';
import WorkshopCard from '../../../Components/WorkshopCard';
import './logicPro.css';
import Loader from '../../../Components/Loader';
import RequestCallbackForm from './RequestCallbackForm';
import { getInternships } from '../../../selectors/internships';

const Internships = ({
  internshipDetails = [],
  getSeminarByType,
  isLoading,
  error
}) => {
  useEffect(() => {
    getSeminarByType('lucknow_internship');
  }, []);

  return (
    <div className="workshop-topics-parent-container">
      <h1 className="workshop-topics-header-container">
        Summer Training Programs are Out, Enroll Today!
      </h1>
      <div className="workshop-topics-child-container">
        {isLoading ? (
          <Loader />
        ) : internshipDetails && internshipDetails.length > 0 ? (
          internshipDetails.map((internship, index) => (
            <WorkshopCard
              seminar={internship}
              buttonText="Request Syllabus"
              isInternship={true}
              viewDetailModalProps={{
                heading: 'About the Internship',
                syllabusHeading: 'Internship Topics'
              }}
              registerModalProps={{
                transparent: true,
                closeButtonStyle: 'close_btn_style',
                style: {
                  overflow: 'hidden',
                  padding: 30,
                  backgroundColor: 'rgba(102,0,0,0.6)',
                  height: 'fit-content',
                  width: 'fit-content'
                },
                children: <RequestCallbackForm />
              }}
            />
          ))
        ) : !internshipDetails ? (
          <p>No data present</p>
        ) : (
          error && (
            <p className="workshop-topics-error-container">
              There was an error. Try again later
            </p>
          )
        )}
      </div>
    </div>
  );
};

const mapStateToProps = (store, props) => ({
  internshipDetails: getInternships(store, props),
  isLoading: store.internshipData.loading,
  error: store.internshipData.error
});

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      getSeminarByType
    },
    dispatch
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Internships);



// WEBPACK FOOTER //
// ./src/Pages/SummerInternships/LogicPro/Internships.js